// Defaults location to be used with maps (Europe)
export const DEFAULT_LOCATION = {
  lat: 48.6908333333,
  lng: 9.14055555556,
  zoom: 6,
};
